import isPointInPolygon from 'point-in-polygon';

export default (objects, rectangle) => {
    const {
        northWest,
        northEast,
        southEast,
        southWest,
    } = rectangle;

    const points = [
        [northWest.x, northWest.y],
        [northEast.x, northEast.y],
        [southEast.x, southEast.y],
        [southWest.x, southWest.y],
    ];

    const list = [];
    for (const object of objects) {
        const { compiled: { polygon: { center } } } = object;
        if (isPointInPolygon([center.x, center.y], points)) {
            list.push((object));
        }
    }

    return list;
};
